export const en = {
  odaPlani: 'Room plan',
  checkIn: 'Check-in',
  kbsDurum: 'Police report status',
  housekeeping: 'Housekeeping',
  raporlar: 'Reports',
  cikisYap: 'Sign out',
  giris: 'Sign in',
  eposta: 'E-mail',
  sifre: 'Password',
  girisYap: 'Sign in',
  cevrimdisi: 'Offline - actions are being saved',
  bekleyenIslem: 'pending action',
  // --- guest mobile (in-room QR)
  hosGeldiniz: 'Welcome',
  oda: 'Room',
  cikis: 'Check-out',
  neLazim: 'What do you need?',
  taleplerim: 'My requests',
  anaEkran: 'Home',
  canli: 'Live',
  talepYok: 'No requests yet',
  talepYokAciklama: 'Open a request from the home screen and follow it here.',
  alindi: 'Received',
  tamamlandi: 'Done',
  iptalEdildi: 'Cancelled',
  nasildi: 'How was it?',
  kopyala: 'Copy',
  kopyalandi: 'Copied',
  resepsiyonaYaz: 'Message the front desk',
  talepAnindaDuser: 'Your request reaches the front desk and housekeeping instantly.',
  gonderiliyor: 'Sending…',
  vazgec: 'Cancel',
  talebiGeriAl: 'Withdraw request',
  gorevliYolda: 'On the way · about {dk} min',
  resepsiyonBakiyor: 'The front desk is checking availability.',
  linkKapali: 'This page is no longer open',
  linkKapaliAciklama: 'The room link works only during your stay. The front desk is happy to help.',
  tekrarDene: 'Try again',
  yukleniyor: 'Loading…',
  baglanilamadi: 'Could not connect.',
  gonderilemedi: 'Could not send.',
  talebinizAlindi: 'Request received',
  talebinizZatenAcik: 'Request already open',
  gecCikisOnayli: 'Late check-out approved',
  rahatsizEtmeyinAcik: 'Do not disturb is on',
  cevrimdisiKuyrukta: 'No connection — your request was saved and will be sent when you are back online.',
  kimlikBaslik: 'Welcome to your room',
  kimlikAciklama: 'Enter your ID number to continue — the national ID or passport number on your booking.',
  kimlikNo: 'ID / passport number',
  devamEt: 'Continue',
  dogrulaniyor: 'Checking…',
  kimlikNeden: 'This step stops anyone who merely knows your room number from seeing your details.',
  oturumBitti: 'Your session expired. Please enter your ID number again.',
} as const;
